import React from 'react'
import SharedToolPage from '../components/Layout/SharedToolPage'
import AdminEmailView from './admin/tools/AdminEmailView'

export default function Email({ embedded = false }) {
  return (
    <SharedToolPage embedded={embedded}>
      <AdminEmailView />
    </SharedToolPage>
  )
}
